import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, mergeMap, tap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ActivitySubscriptionsHttpService } from './activity-subscriptions-http.service';
import { ActivitySubscriptionsActions } from './activity-subscriptions.store';

@Injectable({ providedIn: 'root' })
export class ActivitySubscriptionsEffects {
  private readonly activitySubscriptionsService = inject(ActivitySubscriptionsHttpService);
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  public effects = createEffectFactory(ActivitySubscriptionsActions, this.actions$);

  public fetchActivitySubscriptions$ = this.effects(ActivitySubscriptionsActions.fetch, () =>
    this.activitySubscriptionsService.loadActivitySubscriptions(),
  );

  public updateActivitySubscriptions$ = this.effects(
    ActivitySubscriptionsActions.update,
    ({ payload }) =>
      this.activitySubscriptionsService.updateActivitySubscription(payload).pipe(
        tap(() => {
          this.store.dispatch(ActivitySubscriptionsActions.fetch());
        }),
      ),
  );

  public resetToDefaultActivitySubscriptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivitySubscriptionsActions.resetToDefaults),
      mergeMap(() =>
        this.activitySubscriptionsService
          .resetToDefaultActivitySubscriptionPerRole()
          .pipe(
            map(data => ActivitySubscriptionsActions.resetToDefaultsSuccess({ payload: data })),
          ),
      ),
    ),
  );
}
